import { Company } from "../../../models/Company";
import { Product } from "../../../models/Product";
import { ProductKey } from "../../../models/ProductKey";
import { User } from "../../../models/User";
import { Voucher } from "../../../models/Voucher";

export class VoucherLookupResult {
    searchedKey: string;
    voucher: Voucher | null;
    company: Company | null;
    product: Product | null;
    redeemedBy: User | null;
    productKey: ProductKey | null;

    /* Where the issued key came from, when it was transferred in from another
       product's stock rather than imported against this one. */
    productKeyOriginCompany: Company | null;
    productKeyOriginProduct: Product | null;

    /* Inconsistencies worth flagging to whoever is investigating. */
    warnings: string[];

    constructor(
        searchedKey: string,
        voucher: Voucher | null,
        company: Company | null,
        product: Product | null,
        redeemedBy: User | null,
        productKey: ProductKey | null,
        productKeyOriginCompany: Company | null,
        productKeyOriginProduct: Product | null,
        warnings: string[],
    ) {
        this.searchedKey = searchedKey;
        this.voucher = voucher;
        this.company = company;
        this.product = product;
        this.redeemedBy = redeemedBy;
        this.productKey = productKey;
        this.productKeyOriginCompany = productKeyOriginCompany;
        this.productKeyOriginProduct = productKeyOriginProduct;
        this.warnings = warnings;
    }
}
